import { render, staticRenderFns } from "./comment-section.vue?vue&type=template&id=6214cbac&scoped=true&"
import script from "./comment-section.vue?vue&type=script&lang=js&"
export * from "./comment-section.vue?vue&type=script&lang=js&"
import style0 from "./comment-section.vue?vue&type=style&index=0&id=6214cbac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6214cbac",
  null
  
)

export default component.exports